import { render } from "./OnboardingElectronicAddressPage.vue?vue&type=template&id=2f5ec065&scoped=true"
import script from "./OnboardingElectronicAddressPage.vue?vue&type=script&lang=js"
export * from "./OnboardingElectronicAddressPage.vue?vue&type=script&lang=js"

import "./OnboardingElectronicAddressPage.vue?vue&type=style&index=0&id=2f5ec065&lang=scss"
import "./OnboardingElectronicAddressPage.vue?vue&type=style&index=1&id=2f5ec065&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5ec065"]])

export default __exports__